import { createContext } from 'react'

// Standalone pricing keeps its existing behavior; SearchTile supplies its layout.
const SearchTilePricingColumnContext = createContext(true)

export default SearchTilePricingColumnContext
